'use strict';

function normalizeText(value) {
    return (value || '')
        .toString()
        .toLowerCase()
        .replace(/[áàäâ]/g, 'a')
        .replace(/[éèëê]/g, 'e')
        .replace(/[íìïî]/g, 'i')
        .replace(/[óòöô]/g, 'o')
        .replace(/[úùüû]/g, 'u')
        .replace(/ñ/g, 'n')
        .replace(/\s+/g, ' ')
        .trim();
}

function filterStores(component, locality) {
    var normalizedLocality = normalizeText(locality);
    var stores = component.querySelectorAll('.js-strongpoint-store');
    var count = 0;

    Array.prototype.forEach.call(stores, function (store) {
        var storeLocality = normalizeText(store.getAttribute('data-locality'));
        var showStore = !normalizedLocality || storeLocality === normalizedLocality;

        store.classList.toggle('d-none', !showStore);
        if (showStore) {
            count += 1;
        }
    });

    var countNode = component.querySelector('.js-strongpoint-results-count');
    if (countNode) {
        countNode.textContent = count;
    }
    var clearButton = component.querySelector('.js-strongpoint-clear-filter');
    if (clearButton) {
        clearButton.classList.toggle('d-none', !normalizedLocality);
    }
}

function initComponent(component) {
    var form = component.querySelector('.strongpoint-lockers-filter');
    var select = component.querySelector('#strongpoint-locality-filter');
    var clearButton = component.querySelector('.js-strongpoint-clear-filter');

    // Ensure schedule fallback for stores without schedule defined
    var DEFAULT_SCHEDULE = 'Lunes a sábado, de 9:00 a 21:30 horas, ininterrumpidamente';
    var scheduleNodes = component.querySelectorAll('.js-strongpoint-schedule');
    Array.prototype.forEach.call(scheduleNodes, function (node) {
        var txt = (node.textContent || '').trim();
        if (!txt) {
            node.textContent = DEFAULT_SCHEDULE;
        }
    });

    if (!form || !select) {
        return;
    }

    form.addEventListener('submit', function (event) {
        event.preventDefault();
        filterStores(component, select.value);
    });

    select.addEventListener('change', function () {
        filterStores(component, select.value);
    });

    if (clearButton) {
        clearButton.addEventListener('click', function () {
            select.value = '';
            filterStores(component, '');
        });
    }
}

document.addEventListener('DOMContentLoaded', function () {
    var components = document.querySelectorAll('.strongpoint-lockers-component');
    Array.prototype.forEach.call(components, initComponent);
});
